(function () {
  'use strict';

  /**
   * Frame bundle upsell.
   *
   * Design notes (2026-09-04 fix pack):
   *  - All listeners are delegated from `document`, so they survive the variant
   *    picker being re-rendered by `morph()` on every option change.
   *  - The customer's choice lives in `desiredColor` and is re-applied to the DOM
   *    after each re-render, so the radio state and the JS state can never drift.
   *  - Nothing is captured at boot time: if the picker is not in the DOM yet
   *    (slow connection, in-app browser), we keep looking for it instead of
   *    giving up silently.
   *  - A failed /cart/add.js is reported instead of being swallowed.
   */

  var FRAME_INPUT = 'input[name="frame-bundle-color"]';
  var ATC_FORM = 'form[data-type="add-to-cart-form"]';

  var desiredColor = null;
  var pendingFrameVariantId = null;

  function picker() {
    return document.querySelector('.frame-bundle-picker');
  }

  function readJson(el, key) {
    try {
      return JSON.parse(el.dataset[key] || '{}');
    } catch (err) {
      console.error('[frame-bundle] bad ' + key + ' payload:', err);
      return {};
    }
  }

  function getSizeKey(sizeValue) {
    // Cyrillic "A" is used in UA option values ("A3 30x40 cm") - normalise to Latin.
    var v = (sizeValue || '').toLowerCase().replace(/а/g, 'a');
    if (v.indexOf('50×70') !== -1 || v.indexOf('50x70') !== -1) return '50x70';
    if (v.indexOf('70×100') !== -1 || v.indexOf('70x100') !== -1) return '70x100';
    if (/\ba1\b/.test(v)) return 'a1';
    if (/\ba2\b/.test(v)) return 'a2';
    if (/\ba3\b/.test(v)) return 'a3';
    if (/\ba4\b/.test(v)) return 'a4';
    return null;
  }

  function getSelectedPosterSize() {
    var vp = document.querySelector('.variant-picker');
    if (!vp) return null;

    var fieldsets = vp.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      if (fs.closest('.frame-bundle-picker')) continue;

      var legend = fs.querySelector('legend');
      if (!legend) continue;
      if (!/розмір|размер|size/i.test(legend.textContent)) continue;

      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
    }

    // Fallback: the option may be rendered as a <select> instead of radios.
    var select = vp.querySelector('select');
    return select ? select.value : null;
  }

  function formatCurrency(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var locale = document.documentElement.lang || 'en-GB';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2);
    }
  }

  function displayName(color) {
    var p = picker();
    if (!p) return color;
    var input = p.querySelector(FRAME_INPUT + '[value="' + color + '"]');
    var label = input && input.closest('label');
    var node = label && label.querySelector('.variant-option__frame-name');
    return node ? node.textContent.trim() : color;
  }

  function applyOverlay(color) {
    var p = picker();
    if (!p) return;

    var urls = {
      brown: p.dataset.overlayBrown,
      black: p.dataset.overlayBlack,
      white: p.dataset.overlayWhite
    };

    var mediaEl = null;
    var maxArea = 0;
    document.querySelectorAll('.product-media').forEach(function (el) {
      var r = el.getBoundingClientRect();
      var area = r.width * r.height;
      if (area > maxArea) {
        maxArea = area;
        mediaEl = el;
      }
    });
    if (!mediaEl) return;

    var overlay = mediaEl.querySelector('.frame-bundle-overlay');
    if (!overlay) {
      overlay = document.createElement('img');
      overlay.className = 'frame-bundle-overlay';
      overlay.alt = '';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.style.cssText =
        'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:2;object-fit:fill;';
      mediaEl.style.position = 'relative';
      mediaEl.appendChild(overlay);
    }

    if (!color || color === 'unframed') {
      overlay.style.display = 'none';
      return;
    }
    var src = urls[color];
    if (src) {
      overlay.src = src;
      overlay.style.display = 'block';
    }
  }

  // Show poster (+ selected frame) total on the Add to cart button.
  // Base price is server-rendered into .add-to-cart-text__price on every variant change.
  function formatLike(sample, cents) {
    var m = (sample || '').match(/\d[\d\s.,]*/);
    if (!m) return formatCurrency(cents);
    var num = m[0].trim();
    var dec = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : null;
    // Whole-number sample (e.g. "357 lei"): take the shop's decimal separator from the ATC price span.
    if (!dec && cents % 100) {
      var priceEl = document.querySelector(ATC_FORM + ' .add-to-cart-text__price');
      dec = (priceEl && /^[.,]$/.test(priceEl.dataset.dec)) ? priceEl.dataset.dec : '.';
    }
    var whole = Math.floor(cents / 100);
    var frac = String(cents % 100).padStart(2, '0');
    var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, dec === ',' ? '.' : ',');
    if (dec) out += dec + frac;
    else if (frac !== '00') out += '.' + frac;
    return sample.replace(m[0].trim(), out);
  }

  // Frame price after the storewide promo discount (data-discount-pct on the ATC price, 100 = none).
  function discounted(cents) {
    var span = document.querySelector(ATC_FORM + ' .add-to-cart-text__price');
    var pct = span ? parseInt(span.dataset.discountPct, 10) : 100;
    return pct > 0 && pct < 100 ? Math.floor(cents * pct / 100) : cents;
  }

  function updateAtcPrice() {
    var span = document.querySelector(ATC_FORM + ' .add-to-cart-text__price');
    if (!span) return;
    var base = parseInt(span.dataset.baseCents, 10);
    if (!base) return;
    if (!span.dataset.baseText) return;
    var p = picker();
    var cents = 0;
    if (p && p.style.display !== 'none' && desiredColor && desiredColor !== 'unframed') {
      var prices = readJson(p, 'framePrices');
      var sizeKey = getSizeKey(getSelectedPosterSize());
      cents = (sizeKey && prices[sizeKey] && prices[sizeKey][desiredColor]) ? discounted(prices[sizeKey][desiredColor]) : 0;
    }
    span.textContent = cents > 0 ? formatLike(span.dataset.baseText, base + cents) : span.dataset.baseText;
  }

  function updateLegend() {
    updateAtcPrice();
    var p = picker();
    if (!p) return;

    var legendValue = p.querySelector('.frame-bundle-picker__value');
    if (!legendValue) return;

    var color = desiredColor || 'unframed';
    var name = displayName(color);

    if (color === 'unframed') {
      legendValue.textContent = ': ' + name;
      return;
    }

    var prices = readJson(p, 'framePrices');
    var sizeKey = getSizeKey(getSelectedPosterSize());
    var cents = (sizeKey && prices[sizeKey] && prices[sizeKey][color]) ? discounted(prices[sizeKey][color]) : 0;

    var sampleEl = document.querySelector(ATC_FORM + ' .add-to-cart-text__price');
    var sample = sampleEl && sampleEl.dataset.baseText;
    legendValue.textContent = cents > 0
      ? ': ' + name + ' + ' + (sample ? formatLike(sample, cents).replace(/^\s*·\s*/, '') : formatCurrency(cents))
      : ': ' + name;
  }

  /**
   * Re-apply the customer's choice to the DOM. A `morph()` of the variant picker
   * restores the server-rendered markup, where "unframed" is the checked radio -
   * without this the swatches and `desiredColor` drift apart.
   */
  function sync() {
    var p = picker();
    if (!p) return;

    var checked = p.querySelector(FRAME_INPUT + ':checked');

    if (desiredColor === null) {
      desiredColor = checked ? checked.value : 'unframed';
    } else if (!checked || checked.value !== desiredColor) {
      var wanted = p.querySelector(FRAME_INPUT + '[value="' + desiredColor + '"]');
      if (wanted) {
        wanted.checked = true;
      } else {
        desiredColor = checked ? checked.value : 'unframed';
      }
    }

    // Hide the widget when there is no frame for the selected poster size (e.g. A0),
    // otherwise a chosen frame would be silently dropped on Add to cart.
    var hasFrame = !!getSizeKey(getSelectedPosterSize());
    p.style.display = hasFrame ? '' : 'none';
    if (!hasFrame && desiredColor !== 'unframed') {
      desiredColor = 'unframed';
      var none = p.querySelector(FRAME_INPUT + '[value="unframed"]');
      if (none) none.checked = true;
    }

    updateLegend();
    applyOverlay(desiredColor);
  }

  function reportFrameFailure() {
    var host = document.querySelector('.cart-drawer__summary') || picker();
    if (!host) return;

    var existing = document.querySelector('.frame-bundle-error');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var isUk = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'uk';
    var el = document.createElement('div');
    el.className = 'frame-bundle-error';
    el.setAttribute('role', 'status');
    el.style.cssText = 'font-size:12px;line-height:1.35;color:#c43838;margin:0 0 8px;';
    el.textContent = isUk
      ? 'Рамку не вдалося додати. Спробуйте ще раз або оформіть постер без рамки.'
      : 'We could not add the frame. Please try again, or order the poster unframed.';

    host.insertBefore(el, host.firstChild);
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 8000);
  }

  // --- delegated listeners: attached once, immune to re-renders -------------

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || typeof t.matches !== 'function' || !t.matches(FRAME_INPUT)) return;

    desiredColor = t.value;
    updateLegend();
    applyOverlay(desiredColor);
  });

  document.addEventListener('variant:update', function () {
    sync();
    // The morph may land after the event; re-run on the next frame.
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(sync);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.matches !== 'function' || !form.matches(ATC_FORM)) return;

    pendingFrameVariantId = null;

    var p = picker();
    if (!p) return;
    if (!desiredColor || desiredColor === 'unframed') return;

    var variants = readJson(p, 'frameVariants');
    var sizeKey = getSizeKey(getSelectedPosterSize());
    var id = (sizeKey && variants[sizeKey]) ? variants[sizeKey][desiredColor] : null;

    if (!id) {
      console.warn('[frame-bundle] no frame variant for size=' + sizeKey + ' color=' + desiredColor);
      return;
    }
    pendingFrameVariantId = id;
  }, true);

  document.addEventListener('cart:update', function (e) {
    var data = e.detail && e.detail.data;
    if (!data || data.source !== 'product-form-component' || data.didError) return;
    if (!pendingFrameVariantId) return;

    var variantId = pendingFrameVariantId;
    pendingFrameVariantId = null;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        // fetch() does NOT reject on 4xx/5xx - check explicitly, otherwise a
        // sold-out or stale variant silently looks like a success.
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (body) {
            throw new Error('HTTP ' + res.status + ' ' + (body.description || body.message || ''));
          });
        }
        return res.json().catch(function () { return {}; });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'frame-bundle' } }
        }));
      })
      .catch(function (err) {
        console.error('[frame-bundle] Failed to add frame:', err);
        // Re-render the cart so the customer sees its true contents, then say so.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'frame-bundle' } }
        }));
        reportFrameFailure();
      });
  });

  // --- boot: keep looking for the picker instead of giving up once ----------

  function boot() {
    sync();
    if (picker()) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (picker()) {
        sync();
        clearInterval(timer);
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

